import React from 'react';
import BaseLayout from 'layouts/shared/BaseLayout';
import { ROUTES } from 'constants/routes';
import { CompanyProvider } from 'contexts/CompanyContext';

/**
 * Layout Empresa - Usa BaseLayout con configuración específica para empresa
 * Wrapped with CompanyProvider for company selection state
 */
export default function Admin(props) {
  return (
    <CompanyProvider>
      <BaseLayout
        layoutType="empresa"
        defaultRoute={ROUTES.NUEVA_EMPRESA}
        logoText="TRONA"
        {...props}
      />
    </CompanyProvider>
  );
}
